define(function () {
    return {
        pushEventToGtmDataLayer: function (parameters) {
            var dataLayer = window.dataLayer || [];
            dataLayer.push(parameters);
        }
    };
});
